import { Organization, Project, ProjectNews, ProjectStateStatusEnum, Subproject } from '@/app/api';
import ProjectDonorsTab from '@/app/components/ProjectDonorsTab/ProjectDonorsTab';
import ProjectFAQTab from '@/app/components/ProjectFAQTab/ProjectFAQTab';
import ProjectNewsTab from '@/app/components/ProjectNewsTab/ProjectNewsTab';
import ProjectStoryTab from '@/app/components/ProjectStoryTab/ProjectStoryTab';
import SubprojectTab from '@/app/components/SubprojectTab/SubprojectTab';
import { ProjectTabs } from '@/app/pages/ProjectDetail/types';

type ProjectTabContentProps = {
  project: Project;
  projectNewsLength?: number;
  subProjectsCount?: number;
  activeTabId: ProjectTabs;
  isSubprojectBannerVisible?: boolean;
  projectNews: ProjectNews[];
  handleSelectTab: (tab: ProjectTabs) => void;
  organizationAutorOfProject?: Organization;
  activeSubProjects: Subproject[];
};

export const ProjectTabContent = ({
  project,
  projectNewsLength,
  activeSubProjects,
  activeTabId,
  isSubprojectBannerVisible,
  projectNews,
  handleSelectTab,
  organizationAutorOfProject,
}: ProjectTabContentProps) => {
  switch (activeTabId) {
    case ProjectTabs.DONORS:
      return (
        <ProjectDonorsTab
          projectId={project.id}
          projectNumericId={project.numericId}
          isSubprojectBannerVisible={isSubprojectBannerVisible}
        />
      );

    case ProjectTabs.SUBPROJECT:
      return (
        <SubprojectTab
          activeSubProjects={activeSubProjects}
          projectId={project.id}
          projectNumericId={project.numericId}
          projectMainImage={project.content.mainPhoto ?? undefined}
          projectUrl={`/${project.slug}`}
          isActive={project.state?.status !== ProjectStateStatusEnum.Finished}
        />
      );

    case ProjectTabs.FAQS:
      return (
        <ProjectFAQTab
          projectType={project.settings.modeGroup}
          projectId={project.id}
          projectNumericId={project.numericId}
          isSubprojectBannerVisible={isSubprojectBannerVisible}
        />
      );

    case ProjectTabs.NEWS:
      return (
        <ProjectNewsTab
          projectId={project.id}
          projectNumericId={project.numericId}
          initialData={projectNews}
          initialTotalItemsCount={projectNewsLength}
          isSubprojectBannerVisible={isSubprojectBannerVisible}
        />
      );

    case ProjectTabs.PROJECT:
    default:
      if (!project.content) {
        return null;
      }

      return (
        <ProjectStoryTab
          organizationAuthor={organizationAutorOfProject?.content.name}
          organizationAuthorSlug={organizationAutorOfProject?.slug}
          projectNumericId={project.numericId}
          startedAt={project.timestamps?.startedAt!}
          currentNewsPost={projectNews?.[0]}
          hasMoreNews={!!projectNews && projectNews.length > 1}
          onAllNewsClick={() => handleSelectTab(ProjectTabs.NEWS)}
          isSubprojectBannerVisible={isSubprojectBannerVisible}
          author={project.content.texts.author}
          texts={[
            {
              label: project.content.texts.mainTextLabel ?? undefined,
              htmlContent: project.content.texts.mainText ?? undefined,
            },
            {
              label: project.content.texts.text1Label ?? undefined,
              htmlContent: project.content.texts.text1 ?? undefined,
            },
            {
              label: project.content.texts.text2Label ?? undefined,
              htmlContent: project.content.texts.text2 ?? undefined,
            },
          ]}
        />
      );
  }
};
